import {checkSession_getSelf} from "../lib/api.js"
import "../static/style.css"

const {session: _, user: user} = await checkSession_getSelf();

document.querySelector("#home-button > span").textContent = user.name;

if (user.privileges.includes("admin")) document.querySelector("#admin-button").hidden = false;
if (user.name == "Root") document.querySelector("#debug-button").hidden = false;
